<template>
  <div>
    <div class="header">
      <div class="info-con">
        <span id="name">考试查询</span>
        <div id="totalCountTip">本次期末你有 {{exams.length}} 门考试</div>
        <div id="totalTimeTip">预计考试总时长 {{exams.length * 2}} 小时</div>
        <div class="search-icon"></div>
      </div>
    </div>

    <div class="card-con">
      <div v-for="(exam,index) in exams" :key="index" class="card">
        <div class="name">{{exam.name}}</div>
        <div class="info-item">
          <div class="icon clock-icon"></div>
          <div class="content">{{exam.time}}</div>
        </div>
        <div class="info-item">
          <div class="icon placeholder-icon"></div>
          <div class="content">{{exam.location}}</div>
        </div>
      </div>
    </div>

    <!-- <div class="modal" wx:if="{{showModal}}">
          <div>
              <input bindinput="stuIdInput" focus placeholder="请输入学号" class="stuid-input" type="Text">
          </div>
          <button class="confirm-btn" @tap="query">确定</button>
    </div>-->
  </div>
</template>
<script>
export default {
  data() {
    return {
      exams: [
        { name: '数学', time: '2019-10-10', location: '教学楼102' },
        { name: '数学', time: '2019-10-10', location: '教学楼102' },
        { name: '数学', time: '2019-10-10', location: '教学楼102' },
        { name: '数学', time: '2019-10-10', location: '教学楼102' },
        { name: '数学', time: '2019-10-10', location: '教学楼102' },
        { name: '数学', time: '2019-10-10', location: '教学楼102' },
        { name: '数学', time: '2019-10-10', location: '教学楼102' },
        { name: '数学', time: '2019-10-10', location: '教学楼102' }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.clock-icon {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAABW5JREFUWAnNWU9sFFUYf29mtwiIYUsNdhN3m4AkykHTxP8UbXsEBXsSEyMxHvRApBcTFRMS/5B40YSDHowxMUFPpGA8lkIBo5dGD9ZEAbtL0kpsWZQ/2nZnnr/fm33Dm92Z3ZHWupNs5r3v7+99b973fTMrxS1ep+68eE/V83ZJJXqFEt1KiLyUMk9zSqlpKcS0kGJGSTGRcd1jT/x+9y+34gp20l/jXVPdVU/uU0LtBqh702tCUoqfpJAjGVcd3j7bM5NWNxXAbzvn7riurr4GL8MIz5q0xmPlpLyBGH+wVq57/5HLG/6MlbGILQGO5crPYssOI2pdlt6Sh4jmLB6Jff2VwpfNjDlJTHVQOSdypfd85X+x3ODokzZpmz7oKwlHbAR/2Pjb2rmF+SOI3NNJistJRySPb+hY9dz9l+66Xm+3ATlXs5LgCIiB0D5jItkQQR1ypV6vX8lKzBHJQwOV4hu2rwjA0Vx5j1D+EVug+Vj6UopvkAO/Rho5j5w4TXnkvjwesk0wvlMp8SgoDTuVZNeRzh774IQAmUpu+NfOpzkQOIFVgPhklSvf3jZb0KCSHJ7pKufnPfUWwL8E25kkOUPn6V7j3L7JpKBwZcxzKcGdE454YLBSfKUVODqlDGWpA+fnDJCkOzEEOTeQ0BFkhVj0oNwqCUt5umOd2NVXLlbqHYz1qNucv0rdpPurizP9U/LvepnThVJu4ao4Bj999bzIHMk866rNrDg6gixfrcBx9fXgeOLH1pdewME65V8pX6vOiwv8cUwaeXaO48Joo2UkESiNCah1BEdzU5PNaisMVrlFA5eLP5qVjq6fLgqxeBQHoJc0GJpSUp7RY6W24eD0cAzOhBDZocEr+VIwF+JEZ2mr8MX3TZ9J1O7BSs99Uncli97PRjn2LuXH+jmqMQNwC99hutHIO1L29VeKGuDJXLnPU/644eF+SYiOh22Qo7nSR9i1ly2ZhmEm625x2DI1cCIE6fO0GlKwZYzcTXDkucIJC78j5B9GvnbHQhaP2tsd2JR+nVxkSmyO7uci5OiEec4+rSc/LD9vtjUq2WqmegPdQI42abuZFrHxkOgmM0lQJ2GLifz3ojWNHVal78Ux6nXrbcfo5B1kep0aYpgBCRXC8JhKIP+4mSfd++cKk1lHbnVd5yGUr/BZpC5thHqW7ZBmDYgtAwN5FGuLHB0izGGlYJ7DQ+NGJRpnsEmDk+SMdk59hQyxPZBSbi1X/so5bSd7Bh/YuMVtfCmVQfQYoS1JKHXhrzFZIcR8Gc+XaohiVXl7x3MXP7PteK7qUJ56CvmuRpaev7oQvo9o24ZlK9bG2NiZDBIsw5wIkF2J0WX5QoU4C8XalhkOIAsxvKi84ZsUjKqRGbZMnI2UQMt2VDKYERtSlghXlCC0w6bjufnUnv+bcb0uAOxsqg9sDsKMUpR8IVqPsWUyEk/uL3welC9DSXuXE4FuIE+bsI1eMfkiNocv1cki5CiH/ZyRkQeZ/bNDmKN8pb4gmx0KdAOdwGbzRpbYEGWkgmVoFpKhLq1Z0GkG3cpIsgMeAHTCvhhhP2fkWPgH9hcexEO8N0jG0qoe0iONPMrYTYK2AVtNOxk4MZh0BNu5YdUAGRVs8zsI1ZsmQkl33Ww6YrfdGybJ2vRaD8jIbbbpsWMp3kUveIC8EGC7vjSFAImW32H4OYLjdFfL184dTFPMBOnsCZH42mkMtNuLe8PK+l8tHMAJPG4Ar9SdPum73l9kiw2zrT8eESS/MmE1z2BVhwzo/+pOH/QV92WLPmMjaIP5vz9gtgRIsG39CdiOZtt+RLdBmnHkbwi8GSLfdeN50m0Zu3Q0p+wzp9kyLeVviH8Ao6nDgWpPwHgAAAAASUVORK5CYII=");
  background-size: cover;
}
.placeholder-icon {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAABX1JREFUWAnNWUtsVFUYPudOS5Fa6dBW+sChCbrQjYmCuEBl2oWJC5WNEZdG4yM2BBcaiSSoiUQXNqbGuMPEBBQXIjsX7USphviKJEYXtclQcAq2tTxs6Uw7c/y+e/vfOXdm7sydgrU3mZ7/fb7733P+86hWK3y+7jh3x1I+/5g26h5lVJdRqltr3c1wxpiMViqjtJo0Wv3cEIt9+dDUbWMr6Qpxoj/ftKe7lvJ6wCjzOEDdGd0Tllr9rpU+0RAzQw9O905G9Y0E8PSmmVvmzNVX0Mt+pGdD1OAV7bSeR44Hm3XLu/f/3Xaloo0lrAkwFZ94Ep9sCFlrt/yum0Q2pzEkBpKziU+rBXPClOaQcUbiZ98umMKxGw2OfTImY7MP9hWGo2IGz2y+0DyTyx5F5h4Nc7yRcmTyZNu6pqfuvtg5Vxq3DDnfZjXBERAT4fZZIZNlGXRTbsxrpW+yGjwyebhvdusBu68AwOH4xF5lCkdtg5q01n9idn+htTmFgQUaj1Y9xugHkJs9SE9PzRiWgaOdvfbE8QGylMwX/hmPPCG0uqyMPrhxW+Kj7T/pRasPn/zxXtN4eXzieaXNWwC/0VdUITi7Nzg3b5MS5I9B1rmo4BDkDx1r3Nl/aetQGDhioI42tKVPFVy+ihi8muuJ3AxyhVjMI0CEIgyHKb2+6b7kha60H3WZSHVn3FqZzHRPl+k6J3vNQvZ7LIkdpboyHsW8MWZu54rjZpDLVxRwXiDnGRtcardpGGlNHxyJp9OF+dwUf6Qpo04693ycZ4Wv2iJRLiYYuRkcjqd/i7K2YpaNYpZh8HsP6+V0NpvCZNghsmCrf2hvakra9Q1V4hTKyq6gXQUOa3f/bO9dDnclUcAxBGbqx3aomVzunXBwtDQ7PJuiV2mMoqaEwmaE2BxumUpUVdiGr0SZ6virE8PiReHRZpV2PnB/pOWBzelbL24WVqlijKKsMkVsjrufq6wPSDEWFnfP9Hh1jpqla9sx49whQlZr5+X+2cQAf6Qp40Oba4sL/hBgDMbytNX/EhsnibvJrG6KjrTOYQxiEvpPoAAbo34VjU0vy3xbxmAssa3RdjsI1lXDyFMb0zzaPuG/DPYfgbqmdeHV0fapFv5I2zFt2+/azvVgaDTb+jCa2By8kd9pmKHIc8b4u2jdkvgWvudFh2CP5JbmZvgjLXLa0Fb4rCr4MUQW1hKbv5KEGQXkBfWw8Mm0XgCQA8Kzxfdv5C8ggw1tRWbyxgcvsvDWGHxikwk3KNO85H6iZTGWsU+0VsfKrJYF1NFG9KlN57eg8r4gfK0WCZh0MKMiA8TL3LSQz79pB14Xa34Oc3jMlnm0HvN0RY0pLL2BTtcXJdUpYnPwRpFPWAyHT/j0SOuEXzt3TXdcdRpjT0BVrH2gKaNOINCHvsJHaoHN4bk1knHAyBwZbs1sFVFyassvdu0jTZnoPVtzRPioLbE5PFRHdRA7FN84Stln3O+JrG828SFm3XFU7M9Ji9yzWTxOH5FFbYnNXQmibhZKA8N5sO9Sb3HVWD5T6EO6ILbY1byHT7tf+MitbBbogM3kiciOliE7tscjgQXBueOufnAWJrcO8joCnwYn/pU8wfEoEVY67lx/YHExgXEBenclZlCC19NWGo8cdxyjKxl3Xt9mUO5vXIAU8q6EB5Z6wIktatvOK+NnsTf0HtKUCV9PSwzEIj7uJBGG9zC8jhC+3hbB99EHmXu/Xl+xDz12isFaO7j7n1gAJvclXkc9Oyn8arXsk32X9hf4xKJc05dHBMlTGN5mD97qsID+r1r2wb7sk5/dV8UM2gb/9wVmTYAEu6avgO1srtlLdBuk0IF/Q+BkiMLchfHknm+4S8dumvvMzPX+G+JfjVWJuCxmoGIAAAAASUVORK5CYII=");
  background-size: cover;
}
.search-icon {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAFpElEQVR4XuWbgbEUNwxArQoSKghUEKggUEGSChIqCFQQqCBQQaACoIJABXwqCFQQUoEy78b+4/PKsnZvd//PnWf+DDfns61nWZJlIWnjpqo/pJS+TSnd70z1OaXE3ycR+brxcibDy9oTqiqC/phS+skRujctIN7nvw8iwudN2yoAVJUd/i2l9GtK6e6KK75KKb0Qkdcrjnk01EkAKsGfZDXfap1owrMtQCwGoKrs+LONBW+Bcjwer3k0ZgNQVVT8z5TSw622OzAu2vA80G/YZRYAVUXoN8Fd/zcbM84xO/dVRPj3UctjFi/B+HiNSGPMn0/1HGEAqoqBY+dH7V1K6ZWIvB11tL7PdgUPwvH6bjAGbvORBTY6dwhAUHgsNaq5muvK845AAAG7sAj4EEBA+C+4PxFBJTdpqgqE353BF2uCCyAHNR+didn1J6eewwi1bCvY5W86/YHwYK4GdgHks4jwvcDmtYhgF8yWf5/WhJM3BE3rQXgvIo8iQEsfDwDWHmNkNc7cq44RAxjqCpzFqumAJdT2IDwXEY5MqJkAVBXBARAWPu84ghMV1m3WgiKrDmjCvehRmADIgvzd8fVPReRFu8i8IFxke+P7hBZFFxMRvvQZbFL4KFgAehbXPPNZ+L8aYAiOcdzMMwBCVdkMQnKrER8M5z8C4Ow+ru5+a9A6wr/M8cAud3tVJe6wAqYrEXkw0qoWQG/3JzQ7wneN42ghS7/P7hENtBqhshsgtQD+Mc4+iYmji09HU3YXvrIHqLp1h3BdNb+/BuAYFWv3W00xjePSXZ37O0cLuIDd8carAeDXf2k6fxGRo0DI2P2JhswVYI3+qspN83tjLNcY1gBwfW3U91JEjvy6qvL5j2qisM9dQ9DeGMa6SldXOw8A8q5y/ts2MSLNRO9EpBctbinvZGzn3uKusQDAyFmW9I7h+khelFTYLhehKElVxfW29wTXHRYAlvubnP/oQm6qn6qa3kBEuneeAsCKqG6FcZsDsxcZRgBY5Fa/xMwRZklfJ3FCnmCSj7yOAzqqc04Auq6wHIFz14DLBnDxNiACgBsTL7p1m0SBSwzTnr/pGEHXnXtxwP/RDVob6cpRAFivPsOb1J67G5lLVclit2k5V5MLAH5k5f+7/jOyoL37qKpG7jN1n/o2aMXRN3rPnwPQyWe4t9UagBUL3Jrb3giGqlr5DOqOerVJhyFrAO09n+/RCgjukuAcCel9r6pWOm+owTUAkiEkRdp2Y7m+KBDnAXeYrGmTolZa6bOI3Isu5ib6qSq5jLZiZaj+R0eADw7JW3sxchKiQ/W3AJDt4aGhzaosenreQxtU1cplUp5zN2K75jyNhd/b9hA8a2zvaWz4HlDW2HscxRZYz00htdoDwOBxdGj8ugAyWe95PPTouCWEzrNcmXKWvfIKJKzAosQGJ1VmnQJnIDyv0g8jZ9/VgKwFGESiQ+u1BaPIm8Hw+fkUYdvfZrWnDoG1WS2s+kMAFQTLK5TfU8j8dE0he2OpKq9RbfVJ2536xMdz1hMpkxvV5GAwMY6baEP28+x6tAp9FoQhgKwJTE6ywToOBTgAmHyV0vYsODVHS2qSwxBCAKrjgN9tX5BbjcM+AOutiFA2G2r5fZI3fgTGC412vNQit6m8Ml8IQhhAGTWHy4Do1eq1Ah8KpVNK5sNEFhhhRwLX415b+841OAxhNoDqSOAmo5XdIS0Idpr4+VMgLAJQaQOqijaMqrqDsrnd3GLspRBOAtAcC1yUZySXQOCcY09CVehLIKwCoALBOUYr+Ft6PCjJw25gRGeXwM+FsCqAdouzKysGjnjCiuAwjhhJhCb5cvL/N5gDYVMAS3R+rd9EIZwtgOytehc6vj7UP501gAGEQ+3Q2QNwIBzeDC8CgAEB90re4OpiAGQI5Y6Biz14m4sCYHmY/wAETKlfSreXPgAAAABJRU5ErkJggg==");
  background-size: cover;
  height: 36px;
  width: 36px;
  display: inline-block;
  position: absolute;
  right: 0px;
  top: 20px;
}
.header {
  padding-top: 1px;
  height: 170px;
  background: linear-gradient(#bd10e0, #ff69c8);
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
  box-shadow: 0px 5px 15px rgba(248, 104, 200, 0.3);
}
.info-con {
  margin: 18px 25px;
  color: #fff;
  position: relative;
}
#name {
  font-size: 24px;
}
#stuId {
  font-size: 18px;
  margin-left: 6px;
}
#totalCountTip {
  margin-top: 9px;
  font-size: 15px;
}
#totalTimeTip {
  margin-top: 2px;
  font-size: 15px;
}
.card {
  margin: 0 25px 20px 25px;
  padding: 16px 21px;
  border-radius: 15px;
  background-color: #fff;
  box-shadow: 0px 8px 15px rgba(55, 78, 193, 0.15);
}
.card .name {
  font-size: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.card-con {
  margin-top: -36px;
}
.icon {
  height: 20px;
  width: 20px;
  display: inline-block;
}
.info-item {
  display: flex;
  align-items: center;
  margin-top: 4px;
}
.info-item .content {
  margin-left: 8px;
  font-size: 15px;
  color: #555555;
}
.modal {
  position: absolute;
  top: 135px;
  left: 16px;
  right: 16px;
  padding: 16px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0px 0px 12px #ccc;
}
.stuid-input {
  width: 100%;
  border: none;
  border-bottom: 1px solid #ccc;
  font-size: 22px;
  margin-top: 24px;
  padding: 3px;
}
.confirm-btn {
  background: #bd10e0;
  color: #fff;
  width: 90px;
  margin-top: 12px;
  display: block;
  margin-left: auto;
}
.jser-logo {
  display: flex;
  justify-content: center;
  margin: 25px 0;
}
.jser-logo image {
  width: 100px;
  height: 40px;
}
</style>